import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import BottomBar from './BottomBar';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const TabletLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  // PRD CNH
  // var source = new EventSource('https://eutetechappsvcp02.azurewebsites.net/sse-notifications');

  // CERT CNH
  var source = new EventSource('https://eutetechappsvcc02.azurewebsites.net/sse-notifications');

  // DEV RADA
  //var source = new EventSource('http://localhost:44351/sse-notifications');

  source.addEventListener('alert', function (event) {
    if (event.lastEventId == localStorage.getItem("idteam"))
      alert(event.data)
  });

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />

      {/*  <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      /> */}
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
      <BottomBar /> 
    </div>
  );
};

TabletLayout.propTypes = {
  children: PropTypes.node
};

export default TabletLayout;
